import axios from "./index";

class ProcesosApi {
  // Métodos principales
  static fetchProcesos = () => {
    return axios.get(`/procesos/`);
  };
  // Métodos principales
  static fetchProcesosSoft = () => {
    return axios.get(`/procesos/soft/`);
  };
  static fetchProcesosPaginacion = (params = {}) => {
    return axios.get(`/procesos/paginacion/`, { params });
  };
  static fetchBandejaPaginacion = (params = {}) => {
    return axios.get(`/procesos/bandeja/paginacion/`, { params });
  };
  static fetchBandeja = () => {
    return axios.get(`/procesos/bandeja`);
  };
  static fetchDiasRestantes = (Id) => {
    return axios.get(`/procesos/${Id}/dias_restantes/`);
  };
  static verificarDisponibilidadOperador = (data) => {
    return axios.post(`/procesos/verificarDisponibilidadOperador/`, data);
  };
  static operarProceso = (data) => {
    return axios.post(`/procesos/operarProceso/`, data);
  };
  static obtenerAutoAdmision = () => {
    return axios.get(`/procesos/obtenerAutoAdmision/`);
  };
  static fetchNovedades = (data) => {
    return axios.post(`/procesos/novedades/`, data);
  };
  static operarNovedad = (data) => {
    return axios.post(`/procesos/operarNovedad/`, data);
  };
  static fetchProcesoById = (procesoId) => {
    return axios.get(`/procesos/${procesoId}/`);
  };
  static fetchProcesosByIdentificacion = (identificacion) => {
    return axios.get(`/procesos/?cliente_identificacion=${identificacion}`);
  };
  static fetchProcesoByIdentificador = (procesoIdentificador) => {
    return axios.get(`/procesos/${procesoIdentificador}/consultar/`);
  };
  static eliminarProcesoByIdentificador = (procesoIdentificador) => {
    return axios.delete(`/ninja/procesos/eliminarproceso/${procesoIdentificador}/`);
  };
  static crearProceso = (data) => {
    return axios.post(`/procesos/registrar/`, data);
  };
  static actualizarProceso = (procesoId, data) => {
    return axios
      .patch(`/procesos/${procesoId}/actualizar/`, data)
      .then((response) => {
        if (!response.data) {
          throw new Error("La respuesta no contiene datos");
        }
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };

  // Anexos Proceso
  // Anexos
  static verificarAnexoProceso = (procesoId, params) => {
    return axios.get(`/procesos/anexo/${procesoId}/verificar/`, { params });
  };
  static obtenerAnexosProceso = (procesoId) => {
    return axios.get(`/procesos/${procesoId}/anexosProceso/`);
  };
  static obtenerAnexoProceso = (procesoId, anexoId) => {
    return axios.get(`/procesos/${procesoId}/anexosProceso/${anexoId}/`);
  };
  static obtenerAnexoProcesoByTipo = (procesoId, params) => {
    return axios.get(`/procesos/${procesoId}/anexoProcesoByTipo/`, { params });
  };
  static crearAnexoProceso = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/anexosProceso/registrar/`, data);
  };
  static eliminarAnexoProceso = (procesoId, anexoId) => {
    return axios.delete(`/procesos/${procesoId}/anexosProceso/${anexoId}/eliminar/`);
  };
  static actualizarAnexoProceso = (procesoId, anexoId, data) => {
    return axios.put(`/procesos/${procesoId}/anexosProceso/${anexoId}/actualizar/`, data);
  };

  // Datos básicos
  static fetchResponsables = (data) => {
    return axios.post(`/procesos/responsables/`, data);
  };

  //Audiencias
  static obtenerAudienciasProceso = (id) => {
    return axios.get(`/procesos/audiencias/${id}/`);
  };
  static obtenerAudienciasProcesoSoft = (id) => {
    return axios.get(`/procesos/audiencias/${id}/soft/`);
  };
  static fetchAudienciaById = (audienciaId) => {
    return axios.get(`/procesos/audiencia/${audienciaId}/`);
  };
  static fetchParticipantesAudiencia = (id) => {
    return axios.get(`/procesos/participantes/audiencia/${id}/`);
  };
  static actualizarAudiencia = (id, data) => {
    return axios.put(`/procesos/audiencias/${id}/actualizar/`, data);
  };
  static operarAudiencia = (data) => {
    return axios.post(`/procesos/operarAudiencia/`, data);
  };
  static convocarAudiencia = (audienciaId, data) => {
    return axios.post(`/procesos/audiencia/${audienciaId}/convocar/`, data);
  };

  //Objecionews
  static obtenerObjecionesProceso = (id) => {
    return axios.get(`/procesos/objeciones/${id}/`);
  };
  static obtenerReparosProceso = (id) => {
    return axios.get(`/procesos/reparos/${id}/`);
  };
  static crearObjecion = (data) => {
    return axios.post(`/procesos/objeciones/registrar/`, data);
  };
  static actualizarObjecion = (objecionId, data) => {
    return axios.put(`/procesos/objeciones/${objecionId}/actualizar/`, data);
  };
  static operarObjecion = (data) => {
    return axios.post(`/procesos/operarObjecion/`, data);
  };

  // Clientes
  static fetchClientes = () => {
    return axios.get(`/procesos/clientes/`);
  };

  static fetchClienteByIdentificacion = (identificacion) => {
    return axios.get(`/procesos/clientes/${identificacion}/`);
  };

  // Acreedores
  static fetchAcreedores = () => {
    return axios.get(`/procesos/acreedores/`);
  };

  // Deudas
  static obtenerDeudasProceso = (procesoId) => {
    return axios.get(`/procesos/${procesoId}/deudas/`);
  };
  static crearDeudas = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/deudas/registrar/`, data);
  };
  static eliminarDeuda = (procesoId, deudaId) => {
    return axios.delete(`/procesos/${procesoId}/deudas/${deudaId}/eliminar/`);
  };
  static actualizarDeuda = (procesoId, deudaId, data) => {
    return axios.put(`/procesos/${procesoId}/deudas/${deudaId}/actualizar/`, data);
  };

  // Bienes
  static obtenerBienesProceso = (procesoId) => {
    return axios.get(`/procesos/${procesoId}/bienes/`);
  };

  static crearBien = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/bienes/registrar/`, data);
  };

  static eliminarBien = (procesoId, bienId) => {
    return axios.delete(`/procesos/${procesoId}/bienes/${bienId}/eliminar/`);
  };

  static actualizarBien = (procesoId, bienId, data) => {
    return axios.put(`/procesos/${procesoId}/bienes/${bienId}/actualizar/`, data);
  };

  // Personas a cargo
  static obtenerPersonasCargo = (procesoId) => {
    return axios.get(`/procesos/${procesoId}/personas-cargo/`);
  };

  static crearPersonaCargo = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/personas-cargo/registrar/`, data);
  };

  static actualizarPersonaCargo = (procesoId, personaId, data) => {
    return axios.put(`/procesos/${procesoId}/personas-cargo/${personaId}/actualizar/`, data);
  };

  static eliminarPersonaCargo = (procesoId, personaId) => {
    return axios.delete(`/procesos/${procesoId}/personas-cargo/${personaId}/eliminar/`);
  };

  // Sociedades conyugales
  static obtenerSociedades = (procesoId) => {
    return axios.get(`/procesos/${procesoId}/sociedades/`);
  };

  static crearSociedad = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/sociedades/registrar/`, data);
  };

  static actualizarSociedad = (procesoId, sociedadId, data) => {
    return axios.put(`/procesos/${procesoId}/sociedades/${sociedadId}/actualizar/`, data);
  };

  static eliminarSociedad = (procesoId, sociedadId) => {
    return axios.delete(`/procesos/${procesoId}/sociedades/${sociedadId}/eliminar/`);
  };

  // Procesos Judiciales
  static obtenerProcesosJudiciales = (procesoId) => {
    return axios.get(`/procesos/${procesoId}/procesosjudiciales/`);
  };
  static crearProcesoJudicial = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/procesosjudiciales/registrar/`, data);
  };
  static actualizarProcesoJudicial = (procesoId, procesoJudicialId, data) => {
    return axios.put(
      `/procesos/${procesoId}/procesosjudiciales/${procesoJudicialId}/actualizar/`,
      data
    );
  };
  static eliminarProcesoJudicial = (procesoId, procesoJudicialId) => {
    return axios.delete(`/procesos/${procesoId}/procesosjudiciales/${procesoJudicialId}/eliminar/`);
  };

  // Finanzas
  static obtenerFinanzas = (procesoId) => {
    return axios.get(`/procesos/${procesoId}/finanzas/`);
  };

  static registrarFinanza = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/finanzas/registrar/`, data);
  };

  static actualizarFinanza = (procesoId, finanzaId, data) => {
    return axios.put(`/procesos/${procesoId}/finanzas/${finanzaId}/actualizar/`, data);
  };

  static eliminarFinanza = (procesoId, finanzaId) => {
    return axios.delete(`/procesos/${procesoId}/finanzas/${finanzaId}/eliminar/`);
  };

  static obtenerPropuestas = (id, tipo_propuesta) => {
    return axios.get(`/procesos/propuestas/`, {
      params: {
        proceso_id: parseInt(id),
        tipo_propuesta: tipo_propuesta,
      },
    });
  };
  static obtenerDeudasConciliadasProceso = (procesoId) => {
    return axios.get(`/procesos/${procesoId}/deudas-conciliadas/`);
  };
  static crearPropuesta = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/propuestas/crear/`, data);
  };
  static actualizarPropuesta = (propuestaId, data) => {
    return axios.put(`/procesos/propuestas/${propuestaId}/actualizar/`, data);
  };
  static eliminarPropuesta = (propuestaId) => {
    return axios.delete(`/procesos/propuestas/${propuestaId}/eliminar/`);
  };
  static modificarPropuesta = (propuestaId, data) => {
    return axios.patch(`/procesos/propuestas/${propuestaId}/modificar/`, data);
  };
  static obtenerProyeccion = (propuestaId) => {
    return axios.get(`/procesos/propuestas/${propuestaId}/proyeccion/`);
  };

  // Método mejorado para obtener estadísticas con parámetros opcionales
  static obtenerEstadisticas = (nombreReporte, params = {}) => {
    return axios.get(`/procesos/estadisticas/${nombreReporte}/`, {
      params: params,
    });
  };
  // Nuevo método para obtener filtros dinámicos
  static obtenerFiltrosCartera = () => {
    return axios.get(`/procesos/estadisticas/filtros-cartera/`);
  };

  static obtenerResumenProceso = (procesoIdentificador) => {
    return axios.get(`/procesos/${procesoIdentificador}/resumen/`);
  };
}

export default ProcesosApi;
